import React from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, ArrowLeft, Shield } from 'lucide-react';
import '../styles/modern.css';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ background: 'var(--color-gray-50)' }}>
      {/* Header */}
      <div style={{
        background: 'var(--color-primary)',
        padding: '24px 0'
      }}>
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 text-white">
              <div style={{
                background: 'rgba(255, 255, 255, 0.15)',
                padding: '10px',
                borderRadius: '10px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}>
                <TruckIcon className="w-6 h-6" />
              </div>
              <span className="text-xl font-bold">Transportation Safety Platform</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm mb-8"
          style={{ color: 'var(--color-gray-600)' }}
        >
          <ArrowLeft className="w-4 h-4" />
          Back to login
        </Link>

        <div style={{
          background: '#fbf9f4',
          borderRadius: 'var(--radius-xl)',
          padding: '48px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
          border: '1px solid var(--color-gray-200)'
        }}>
          <div className="flex items-center gap-4 mb-8">
            <div style={{
              width: '56px',
              height: '56px',
              background: 'var(--color-primary)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Shield className="w-7 h-7 text-white" />
            </div>
            <h1 className="text-3xl font-bold" style={{ color: 'var(--color-gray-900)' }}>
              Privacy Policy
            </h1>
          </div>

          <div className="prose max-w-none" style={{ color: 'var(--color-gray-700)' }}>
            <p className="text-muted mb-6">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>1. Information We Collect</h2>
            <p className="mb-4">We collect information you provide directly to us, including:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Account information (name, email, company details)</li>
              <li>Transportation and safety data (DOT numbers, carrier information)</li>
              <li>Usage data and analytics</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>2. How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices and security alerts</li>
              <li>Respond to your requests and support needs</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>3. Data Security</h2>
            <p className="mb-4">
              We implement appropriate technical and organizational measures to protect your personal 
              data against unauthorized access, alteration, disclosure, or destruction. Our platform 
              uses industry-standard encryption and security practices.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4" style={{ color: 'var(--color-gray-900)' }}>4. Contact Us</h2>
            <p className="mb-4">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@tsap.ai" style={{ color: 'var(--color-primary)' }}>privacy@tsap.ai</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
